import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { GDPRConsentService } from '../shared/gdpr-consent/gdpr-consent.service';
import { map, catchError, of } from 'rxjs';

/**
 * Cached GDPR consent status — once consent is confirmed, skip further checks
 * for the lifetime of the app session.
 */
let gdprConsentConfirmed = false;

export function resetGdprConsentCache() {
  gdprConsentConfirmed = false;
}

export const gdprGuardFn = () => {
  if (gdprConsentConfirmed) {
    return true;
  }

  const router = inject(Router);
  const gdprService = inject(GDPRConsentService);

  return gdprService.getConsentStatus().pipe(
    map((status) => {
      if (status.needs_consent) {
        return router.createUrlTree(['/profile']);
      }
      gdprConsentConfirmed = true;
      return true;
    }),
    catchError(() => of(true)) // Don't block navigation if the check fails
  );
};
